module.exports = __webpack_public_path__ + "static/media/cardio1.44e1a9d2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/program_categories/cardio1.jpg
// module id = 320
// module chunks = 0